const body = document.querySelector('body');
const mobileMenuButton = document.getElementById('main_nav_button');
const mainNav = document.getElementById('main_nav');
const skipNavLink = document.getElementById('skip_nav_link');
let   mobileMenuIsTransitioning = null;
let 	mainNavLinks = null;


/**
 *
 *
 *
 */
const init = function() {

	if ( mainNav !== null ) {

		mainNavLinks = mainNav.querySelectorAll('li a');

    setupMobileMenuEventListeners()
    setupMenuLinkListeners();

	}

};


/**
 * Shows or hides the mobile by modifying classes & aria
 * attributes.
 *
 * @param state String "Show" to show the menu, anything else to hide
 * @return none
 *
 */
const toggleMobileMenu = function( forceState ) {

	if ( mobileMenuIsTransitioning !== null ) return;

	const bodyOverlayClass = 'has-mute-overlay';
	const bodyOverlayVisibleClass = 'has-visible-overlay';
	let 	menuStateToActivate = ( body.classList.contains(bodyOverlayClass) ) ? 'hide' : 'show';

	if ( forceState === 'hide' ) menuStateToActivate = 'hide';

	if ( menuStateToActivate === 'show' ) {

		// add body class to trigger mute overlay
		body.classList.add(bodyOverlayClass);
		mobileMenuButton.setAttribute('aria-expanded', 'true');
		mainNav.classList.add('has-entered');

		mobileMenuIsTransitioning = setTimeout( () => {
			mainNav.classList.add('is-visible');
			body.classList.add(bodyOverlayVisibleClass);
			mobileMenuIsTransitioning = null;
		}, 100 );

	} else {

		body.classList.remove(bodyOverlayVisibleClass);
		mobileMenuButton.setAttribute('aria-expanded', 'false');
		mainNav.classList.remove('is-visible');

		mobileMenuIsTransitioning = setTimeout( () => {
			mainNav.classList.remove('has-entered');
			body.classList.remove(bodyOverlayClass);
			mobileMenuIsTransitioning = null;
		}, 400 );

	}

};


/**
 * Sets up event listeners for showing/hiding the main menu
 * in its mobile format. These event listeners work hand-in-hand
 * to hide the menu when it loses focus or when something outside
 * the menu has been clicked.
 *
 * @param none
 * @return nothing
 *
 */
const setupMobileMenuEventListeners = function() {

	mobileMenuButton.addEventListener('click', toggleMobileMenu);

	// hide the mobile menu if the skip nav link is clicked
	if ( skipNavLink !== null ) {
		skipNavLink.addEventListener('click', function(){
			toggleMobileMenu('hide');
		});
	}

	// on both click and focusin...
	['click', 'focusin'].forEach( function(ev) {

		// When the body is clicked or focused, hide the mobile menu
		body.addEventListener(ev, function(){
			toggleMobileMenu('hide');
		}, false);

		// When the mobile menu button is clicked or focused stop propagation
		mobileMenuButton.addEventListener(ev, function(ev){
			ev.stopPropagation();
		}, false);

		// When the main nav is clicked or focused, stop propagation
		mainNav.addEventListener(ev, function(ev){
			ev.stopPropagation();
		}, false);

	});

	// Escape key closes menu
	window.addEventListener('keyup', (e) => {
		if ( e.key === 'Escape' || e.key === 'Esc' ) { // deprecated: e.keyCode === 27
			toggleMobileMenu('hide');
			e.preventDefault();
			return false;
		}
	}, true);

};



/**
 * 
 * 
 * 
 */
const setupMenuLinkListeners = function() {

  mainNavLinks.forEach( ( element ) => {
    element.addEventListener( 'click', () => {
      setTimeout( () => {
        toggleMobileMenu('hide');
      }, 200 );
    } );
  } );

}



const api = {
	init: init
};

export default api;